function MTA () {
    //腾讯埋点
    // sit:500675714   09f9d4d227126f0e5a51ac8862877aaa     https://mta.qq.com/h5/base/ctr_overview?app_id=500675714
    // stg:500675715   d752f80528a0169628f9d0cd882244d6     https://mta.qq.com/h5/base/ctr_overview?app_id=500675715
    // prod:500674791  a8c167be5fc0e6b73a0effbd8ef6aab5     https://mta.qq.com/h5/base/ctr_overview?app_id=500674791
    var _mtac = {"senseQuery":1};
  	(function() {
  		var mta = document.createElement("script");
  		mta.src = "//pingjs.qq.com/h5/stats.js?v2.0.4";
  		mta.setAttribute("name", "MTAH5");
        mta.setAttribute("sid", process.env.MTAsid); 
        mta.setAttribute("cid", process.env.MTAcid);
  		var s = document.getElementsByTagName("script")[0];
  		s.parentNode.insertBefore(mta, s);
  	})();
    
}
export default MTA




// WEBPACK FOOTER //
// ./src/utils/MTA.js